<script>
import { mapState } from "vuex";
import { EF_TRACKING_URL, NAME_GIBBERISH_WHITELIST } from "@/paths/constants";

export default {
  props: {
    prepare: {
      type: Boolean,
      default: false,
    },
    customProps: {
      type: Object,
      default: () => ({}),
    }
  },

  data() {
    return {
      loading: null,
      firstName: "",
      lastName: "",
      hasError: false,
      fistNameError: false,
      emptyFirstNameFieldError: false,
      invalidFistNameFieldError: false,
      lastNameError: false,
      emptyLastNameError: false,
      invalidLastNameError: false,
      fieldInvalidError: false,
    };
  },

  computed: {
    ...mapState([
      "fields",
      "fieldsFromUrl",
      "fieldsFromStorage"
      ]),
  },

  created() {
    if (this.prepare) {
      if(!(this.fieldsFromUrl["first_name"] === undefined) || !(this.fieldsFromUrl["last_name"] === undefined)) {
        this.firstName = this.fieldsFromUrl["first_name"];
        this.lastName = this.fieldsFromUrl["last_name"];
      } else if (!(this.fieldsFromStorage["First_Name"] === undefined) || !(this.fieldsFromStorage["last_name"] === undefined)) {
        this.firstName = this.fieldsFromStorage["First_Name"];
        this.lastName = this.fieldsFromStorage["last_name"];
      }

      const valid = this.validate();
      if (!valid) {
        this.$emit("show-this-step");
      } else {
        this.setAnswersAndGoToNext();
      }
    }
  },

  methods: {
    async setAnswer(answer) {
      this.loading = null;
      const valid = this.validate();
      if (!valid) return;
      this.loading = answer;

      this.setAnswersAndGoToNext();
      // await this.progressionTracking();
    },

    setAnswersAndGoToNext() {
      let nameGibberish = this.isNameGibberish(this.firstName) ? 'yes' : 'no'
      if (nameGibberish === 'no') {
        nameGibberish = this.isNameGibberish(this.lastName) ? 'yes' : 'no'
      }

      let nameBadWord = this.blackList().test(this.firstName.toLowerCase()) ? 'yes' : 'no'
      if (nameBadWord === 'no') {
        nameBadWord = this.blackList().test(this.lastName.toLowerCase()) ? 'yes' : 'no'
      }

      this.$store.dispatch("setAnswers", [
        {
          field: "First_Name",
          value: this.firstName,
        },
        {
          field: "last_name",
          value: this.lastName,
        },
        {
          field: 'name_gibberish',
          value: nameGibberish
        },
        {
          field: 'name_bad_word',
          value: nameBadWord
        }
      ]);
      this.$emit("next-step");
    },

    validate: function () {
      const validFirstName = this.validateFirstName();
      const validLastName = this.validateLastName();

      return validFirstName && validLastName;
    },

    blackList() {
      const badWordsList = [
        "Anitadick",
        "Ass",
        "Asshead",
        "Asswhipe",
        "Bad",
        "Bitch",
        "Boner",
        "Cockboy",
        "Cockman",
        "Cum",
        "Cunt",
        "Dick",
        "Dickeater",
        "Dickhead",
        "Diddlier",
        "Dog",
        "Donkey",
        "Dumb",
        "Erec ",
        "Fat",
        "Fatass",
        "Fuck",
        "Fucked",
        "Fucker",
        "Fuckhead",
        "Fucktard",
        "Good",
        "He",
        "Her",
        "His",
        "HughJass",
        "huge",
        "I",
        "Ip",
        "Ipe",
        "Ipee",
        "Jackass",
        "Jackle",
        "Jerk",
        "Jerker",
        "Jizz",
        "King",
        "Large",
        "Midget",
        "Murder",
        "No",
        "Obese",
        "Our",
        "Ours",
        "Penis",
        "piss",
        "Prick",
        "PrickDick",
        "Rape",
        "She",
        "Shit",
        "Stupid",
        "Tits",
        "Tion ",
        "Torture",
        "Troll",
        "Vagina",
        "What",
        "When",
        "Who",
        "Why",
        "Yes",
        "You",
        "Big",
        "Bigdick",
        "Semen",
        "hentai",
        "spongebob",
        "squarepants",
        "faggot",
        "pos",
        "fag",
        "puto",
        "madre",
        "nigger",
        "nigga",
        "nig",
        "ger",
        "cracker",
        "blowjob",
        "blow",
        "hardon",
        "eat",
        "rimjob",
        "fuckyou",
        "asswipe",
        "cock",
        "sex",
        "sexy",
        "fisting",
        "dildo",
        "bluewaffle",
        "pedophile",
        "pedo",
        "sexual",
        "asshole",
        "meoff",
        "jackmeoff",
        "niger",
      ];
      return new RegExp(`^(${badWordsList.join("|").toLowerCase()})$`,"ig");
    },

    validateFirstName() {
      if (!this.firstName || this.firstName.length === 0) {
        this.fistNameError = true;
        this.emptyFirstNameFieldError = true;
      } else {
        return true;
      }
    },

    validateLastName() {
      if (!this.lastName || this.lastName.length === 0) {
        this.lastNameError = true;
        this.emptyLastNameError = true
      } else {
        return true;
      }
    },

    isNameGibberish(name) {
      if (NAME_GIBBERISH_WHITELIST.includes(name.toLowerCase())) return false

      //checking if name has any prefixes or suffixes is highest priority to ignore the name suffix when running name gibberish tests
      name = this.removePrefixInNameIfExists(name).trim()
      name = this.removeSuffixInNameIfExists(name).trim()

      //check if name has a special character that connects name ('-') => if name has hyphen, split the str
      //the reason we choose to only remove hyphens is because if we attempt to remove any special character
      //we are defeating the point of checking for name gibberish, if we checked and removed >?!<| etc, we would end up
      //not flagging an incorrect name

      //check if name has a special character that connects name (' ', '-') => if name has hyphen, and replace with empty space string
      name = name.replace(/[-.,]/m, ' ')

      //remove excess white space
      name = name.replace(/\s+/g, ' ').trim()

      const splitName = name.split(' ')

      //remove any initials
      for (let namePart of splitName) {
        if (namePart.length <= 1) {
          splitName.splice(splitName.indexOf(namePart), 1)
        }
      }

      //iterate through array of split names to test individually only if name has hyphen, otherwise proceed with regular check
      return this.iterateTests(splitName)
    },

    regexNameGibberishTest(name) {
      // has less than 2 chars
      if (name.length < 2) {
        return true
      }

      // has no vowels
      if (!/[aeiouyāēīōūȳáéíóúýäöü]/i.test(name)) {
        return true
      }

      // has three consecutive chars
      if (/([A-Za-zÀ-ÖØ-öø-ÿ])\1\1+/.test(name)) {
        return true
      }

      // no vowels in 5 chars
      if (/[^aeiouyāēīōūȳáéíóúýäöü]{5}/mi.test(name)) {
        return true
      }
      return false
    },

    removePrefixInNameIfExists(name) {
      //remove any prefix in name
      const prefixRegex = /^(hr|fr|md|dr|mr|mrs|miss|ms|sir|sr)(\.|\s+)/i
      if (prefixRegex.test(name)) {
        return name.replace(prefixRegex, "").trim()
      }
      return name
    },

    removeSuffixInNameIfExists(name) {
      //remove suffix in name
      const suffixRegex = /(?:,|-|\s+)(?:i|ii|iii|iv|jr|sr|dds|phd|md|dvm)\.?$/i
      if (suffixRegex.test(name)) {
        return name.replace(suffixRegex, "").trim()
      }
      return name
    },

    iterateTests(nameArray) {
      for (const name of nameArray) {
        const regexNameGibberish = this.regexNameGibberishTest(name)
        if (regexNameGibberish) return true
      }
      return false
    },

    async progressionTracking() {
      const eventID = this.customProps.trackProgress ? "39" : "60"
      await this.axios.post(`${EF_TRACKING_URL}&event_id=${eventID}&transaction_id=${this.fields['transaction_id']}`)
    },

    handleFirstNameChange() {
      this.fistNameError = false;
      this.emptyFirstNameFieldError = false;
      this.invalidFistNameFieldError = false;
    },

    handleLastNameChange() {
      this.lastNameError = false;
      this.emptyLastNameError = false;
      this.invalidLastNameError = false;
    },
  },
};
</script>

<template>
  <div v-if="!prepare">
    <div class="container is-max-widescreen">
      <div class="has-text-centered item-box px-5">
        <h2 class="question mb-3">
          You're almost done!<br />
          Tell us a little about yourself to complete your insurance profile.
        </h2>
        <form
          class="container is-max-widescreen"
          @submit.prevent="setAnswer('Continue')"
        >
          <b-field
            class="has-text-left"
            :type="fistNameError ? 'is-danger' : ''"
            :message="[
              { 'Please enter your first name.': emptyFirstNameFieldError },
              { 'Please enter a valid first name.': invalidFistNameFieldError },
            ]"
          >
            <b-input
              class="mt-5"
              v-model.trim="firstName"
              type="text"
              placeholder="First Name"
              @input="handleFirstNameChange"
            >
            </b-input>
          </b-field>
          <b-field
            class="has-text-left"
            :type="lastNameError ? 'is-danger' : ''"
            :message="[
              { 'Please enter your last name.': emptyLastNameError },
              { 'Please enter a valid last name.': invalidLastNameError },
            ]"
          >
            <b-input
              class="mt-5"
              v-model.trim="lastName"
              type="text"
              placeholder="Last Name"
              @input="handleLastNameChange"
            >
            </b-input>
          </b-field>
          <input
            type="submit"
            value="Continue"
            class="submitButton mt-3"
            :loading="loading === 'Continue'"
            :disabled="loading !== null"
          />
        </form>
      </div>
    </div>
  </div>
</template>
